
import Vue from "vue";
export default Vue.extend({
	methods: {
		switchSession(){
			this.$emit("switch");
		},
		signout(){
			this.$emit("signout");
		}
	},
	i18nEx: {
		componentPrefix: "views.TheMain"
	}
});
